<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 30.443 28.935">
        <g id="password" transform="translate(-75 -272)">
            <g id="Group_2708" data-name="Group 2708" transform="translate(29 98)">
                <circle id="Ellipse_46" data-name="Ellipse 46" cx="13.5" cy="13.5" r="13.5"
                        transform="translate(46 174)" fill="#c0d0fc" opacity="0.7"/>
            </g>
            <g id="password-2" data-name="password" transform="translate(52.557 277.065)">
                <g id="Group_2397" data-name="Group 2397" transform="translate(32)">
                    <g id="Group_2396" data-name="Group 2396">
                        <circle id="Ellipse_31" data-name="Ellipse 31" cx="1" cy="1" r="1"
                                transform="translate(12.443 14.935)" fill="#799cfb"/>
                        <path id="Path_69778" data-name="Path 69778"
                              d="M51.953,16.876a.932.932,0,0,0,.932-.932v-3.45a3.734,3.734,0,0,0-3.73-3.73H48.035V5.476a5.6,5.6,0,0,0-11.189,0V8.764H35.73A3.734,3.734,0,0,0,32,12.494V20.14a3.734,3.734,0,0,0,3.73,3.73H49.156a3.734,3.734,0,0,0,3.73-3.73.932.932,0,1,0-1.865,0A1.867,1.867,0,0,1,49.156,22H35.73a1.867,1.867,0,0,1-1.865-1.865V12.494a1.867,1.867,0,0,1,1.865-1.865H49.156a1.867,1.867,0,0,1,1.865,1.865v3.45A.932.932,0,0,0,51.953,16.876ZM46.171,8.764H38.711V5.476a3.731,3.731,0,0,1,7.459,0Z"
                              transform="translate(-32)" fill="#799cfb"/>
                        <circle id="Ellipse_33" data-name="Ellipse 33" cx="1" cy="1" r="1"
                                transform="translate(5.443 14.935)" fill="#799cfb"/>
                        <circle id="Ellipse_34" data-name="Ellipse 34" cx="1" cy="1" r="1"
                                transform="translate(9.443 14.935)" fill="#799cfb"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ILockMasked",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
